<template>
  <div id="root" class="toggle-menu">
    <menu-component whiteFont="true"></menu-component>
    <b-row class="full-height bg-img">
			<b-container class="alinov-header center-text">
        <b-row>
          <b-col>
            <h1>Nosotros</h1>
            <span>Conoce nuestra misión, visión y valores</span>
            <br/><br>
            <a class="link-to-section" href="#about-us">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <div id="about-us" class="alinov-info-container">
        <b-container class="info">
          <b-row class="title">
            <h1>
              ¿Quiénes somos?
            </h1>
          </b-row>
          <b-row>
            <b-col>
              <h2>Misión</h2>
              <p>
                Diseñar modelos de negocios innovadores, ser puente entre el campo y la
		tecnología mejorando la calidad de vida deL sector agropecuaro..
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
							<h2>Visión</h2>
              <p>
               Ser pioneros en la revolución del sector agropecuario, proveer modelos y servicios
		innovadores de la mano con la tecnología, ayudando a la regeneración del medio
		ambiente.
              </p>
						</b-col>
          </b-row>
          <b-row>
            <b-col>
              <h2>Valores</h2>
	      <ul style="list-style-type:none;">
  		<li>Honestidad</li>
 		 <li>Confianza</li>
		  <li>Lealtad</li>
		  <li>Mejora continua</li>
 		  <li>Respeto</li>
		  <li>Compromiso social y ambiental</li>
		  <li>Innovación y calidad </li>
		</ul>  
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-row>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Menu from "../shared/Menu.vue";
import Footer from '../shared/Footer.vue';
import $ from 'jquery'

export default {
  name: "About",
  components: {
    "menu-component": Menu,
    'footer-component': Footer
  },
  beforeMount() {
    $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top-80}, 500, 'linear');
      });
    });

    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
			var headerHeight = 500;
			// $('.alinov-header').height() + 100;

      if (scroll >= headerHeight) {
					$(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-bg");
					$(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-font");
      } else {
				$(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-bg");
				$(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-font");
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.full-height {
    background-image: linear-gradient( 
      rgba(0, 0, 0, 0.2), 
      rgba(0, 0, 0, 0.2) ),  
      url("../assets/images/agridron.jpg");
}
</style>
